import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { TableContext } from '../../../components/Table/TableContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useAcceptKyc = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const tableContext = useContext(TableContext);


    const onAcceptKycError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while accepting kyc.',
        );
    };

    const onAcceptKycSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setShowSuccessModal(true);
        tableContext?.setRefreshTable(!tableContext?.refreshTable);
    };

    const acceptKyc = async (companyId: any) => {
        const url: HttpConfig = {
            url: `ba/v1/company/${companyId}/kyc/accept`,
            method: 'put',
            // data: data
        };

        await request(url, onAcceptKycSuccess, setLoading, onAcceptKycError);
    };

    return { acceptKyc, loading, showSuccessModal, setShowSuccessModal };
};

export default useAcceptKyc;
